import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MyObservation } from 'libs/end-to-end/src/my-observation';

/**
 * Returns if the focus area has content to show or should show empty state
 */
export const isEmptyFocusArea = ({
  myObservation,
  focusArea,
}: {
  myObservation?: MyObservation | null;
  focusArea: FocusArea | null;
}) => {
  if (!focusArea) {
    return true;
  }

  const disabled = myObservation?.focusAreas?.every(
    (fa) => fa.focusArea !== focusArea,
  );

  return disabled;
};

/**
 * Returns the href for the focus area. Does not depend on the page routes to ensure we don't create a circular dependency on components.
 * @param focusArea
 */
export const getFocusAreaHref = (focusArea: FocusArea) => {
  return `/${focusArea.toLowerCase()}`;
};
